const getToken = () => localStorage.getItem("other");

const handleError = (error, setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg) => {
  if (setMessageBox) {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>{error}</span>
        </div>
      </div>
    );
    setIsMessageBoxVisible(true);
    if (setActiveImg && ErrorImg) setActiveImg(ErrorImg);
  }
};

export const GET = {
  noToken: async (url, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg } = {}) => {
    try {
      const response = await fetch(url, { headers: { accept: "application/json" } });
      return await response.json();
    } catch (err) {
      handleError("Error: " + err.message, setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg);
      return null;
    }
  },
  withToken: async (url, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg } = {}) => {
    try {
      const response = await fetch(url, {
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      return await response.json();
    } catch (err) {
      handleError("Error: " + err.message, setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg);
      return null;
    }
  },
};

export const POST = {
  noToken: async (url, body, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg } = {}) => {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    } catch (err) {
      handleError("Error: " + err.message, setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg);
      return null;
    }
  },
  withToken: async (url, body, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg } = {}) => {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    } catch (err) {
      handleError("Error: " + err.message, setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg);
      return null;
    }
  },
};

export const PUT = {
  noToken: async (url, body, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg } = {}) => {
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    } catch (err) {
      handleError("Error: " + err.message, setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg);
      return null;
    }
  },
  withToken: async (url, body, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg } = {}) => {
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    } catch (err) {
      handleError("Error: " + err.message, setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg);
      return null;
    }
  },
};